import React from 'react';

import PillComponent from '../../../../../../common/genericComponents/pillComponent/pillComponent';
import UpgradeComponent from '../../../../../../common/genericComponents/redesign/upgradeComponent/upgradeComponent';

import './expertRightSettingsMainSubTitleComponent.css';
import QuestionWithTooltipComponent from '../../../../../../common/genericComponents/redesign/questionWithTooltipComponent/questionWithTooltipComponent';

const ExpertRightSettingsMainSubTitleComponent = ({
  billingPlanFeature = null,
  pillType = null,
  subTitleTxt = '',
  subToolTipTxt = null,
  subToolTipPosition = 'bottom',
}) => {
  return (
    <div className="et-v2-ers-main-sub-title-container">
      <div className="et-v2-ers-main-sub-title-txt">{subTitleTxt}</div>
      {subToolTipTxt && (
        <div className="et-v2-sub-title-tooltip-wrap">
          <>
            <div className="et-n-input-title-tooltip-upgrade-btn-separator" />
            <QuestionWithTooltipComponent
              toolTipPosition={subToolTipPosition}
              toolTipTxt={subToolTipTxt}
            />
          </>
        </div>
      )}
      {pillType && <PillComponent pillType={pillType} />}
      <UpgradeComponent isCrown billingPlanFeature={billingPlanFeature} />
    </div>
  );
};

export default ExpertRightSettingsMainSubTitleComponent;
